import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import Iconify from '@/components/Iconify';
import { usePromotionForm } from '@/sections/promotion';
import { useEvent } from '@/store';
import { fCurrency } from '@/utils/formatNumber';

function PromotionBanner({ showClearButton = false }) {
  const { t } = useTranslation();
  const { promotions, clearPromotion } = usePromotionForm();
  const {
    event: {
      preferences: { currency },
    },
  } = useEvent();
  const getDiscount = () => {
    if (promotions.bundle_rule) {
      return `${promotions.bundle_rule}`;
    }
    if (promotions.discount_type === 'percentage') {
      return t('checkout.coupons.discountPercentage', {
        percentage: promotions.discount_amount,
      });
    }
    if (promotions.discount_type === 'flat') {
      return t('checkout.coupons.discountAmount', {
        amount: `${fCurrency(promotions.discount_amount)} ${currency}`,
      });
    }
  };

  return (
    <>
      {promotions?.code && (
        <Box
          sx={{
            width: '100%',
            height: '40px',
            border: '1px solid #139e65 ',
            color: '#139e65',
            background: '#e8fcf4',
            borderRadius: '10px',
            mb: 2,
            mt: 2,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              height: '40px',
              alignItems: 'center',
            }}
          >
            <Box sx={{ ml: 1, height: '20px' }}>
              <Iconify width={14} height={14} icon={'mdi:tag'} />
            </Box>
            <Typography variant="caption" sx={{ ml: 1, lineHeight: '14px' }}>
              {`${getDiscount()} ${
                promotions.valid_for_ticket_type === 'all'
                  ? t('checkout.coupons.inAllTickets')
                  : t('checkout.coupons.inSomeTickets')
              }`}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {showClearButton && (
              <Box sx={{ mr: 1, height: '30px' }}>
                <IconButton
                  sx={{ color: (theme) => `${theme.palette.secondary.main}` }}
                  onClick={() => {
                    clearPromotion();
                  }}
                >
                  <Iconify
                    width={14}
                    height={14}
                    icon={'material-symbols:close'}
                  />
                </IconButton>
              </Box>
            )}
          </Stack>
        </Box>
      )}
    </>
  );
}

export default PromotionBanner;
